<template>
  <div class="mainContent">
    <router-link :to="{ path:'cardBag'}" tag="div" class="tab cardBag">
        <div class="card">
            <span class="font fontOne">卡包</span>
        </div>
    </router-link>
    <router-link :to="{ path:'find'}" tag="div" class="tab discover">
        <div class="card">
            <span class="font fontOne">发现</span>
        </div>
    </router-link>
    <router-link :to="{ path:'mine'}" tag="div" class="tab mine" >
        <div class="cardOne" @click="getFile">
            <span class="font fontOne">我的</span>
        </div>
    </router-link>
  </div>
</template>
<script>
    export default{
        name:"bottom",
        data(){
            return{
                oneSelg:true,
                acti:true
           }
        },
         computed:{
            wsWbsocket(){
                return this.$store.state.wsWbsocket;
                }
           },
           methods:{
               getFile(){
                   
               }
           }
    }
</script>
<style scoped>
.mainContent{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.32rem;
    border-top:0.03rem solid rgba(0,0,0,0.20); 
    background: white;
    z-index: 99;
    display: table;
}

@media (max-height: 400px) { 
  .mainContent {
    display: none;
  }
}

.card,.cardOne{
    width: 100%;
    padding-top: 0.25rem;
}
.fontOne{
    display: block;
    position:relative;
    top: 0.2rem;
}
div .font{
    font-size: 0.31rem;
}
.tab {
    background-repeat: no-repeat;
    background-size:0.63rem auto;
    line-height:1.5rem;
    display: table-cell;
    background-position:50% 25%;
    text-align: center; 
}
.cardBag{
    background-image: url("../../assets/images/cardBag0.png");
}
.discover{
    background-image: url("../../assets/images/find0.png");
}
.mine{
    background-image: url("../../assets/images/mine0.png");
}
.cardBag.router-link-active{
    background-image: url("../../assets/images/cardBag1.png");
    background-repeat: no-repeat;
    background-size:0.63rem auto;
    background-position:50% 20%;
    }
.discover.router-link-active{
    background-image: url("../../assets/images/find1.png");
    background-repeat: no-repeat;
    background-size:0.63rem auto;
    background-position:50% 20%;
}
.mine.router-link-active{
    background-image: url("../../assets/images/mine1.png");
    background-repeat: no-repeat;
    background-size:0.63rem auto;
    background-position:50% 20%;
}
</style>


// WEBPACK FOOTER //
// src/components/footerTo/bottom.vue